var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.1298C11.33 23.1298 10.65 22.9798 10.12 22.6698L4.61999 19.4998C2.37999 17.9898 2.23999 17.7598 2.23999 15.3898V9.6098C2.23999 7.2398 2.36999 7.0098 4.56999 5.5198L10.11 2.3198C11.16 1.7098 12.81 1.7098 13.86 2.3198L19.38 5.4998C21.62 7.0098 21.76 7.2398 21.76 9.6098V15.3798C21.76 17.7498 21.63 17.9798 19.43 19.4698L13.89 22.6698C13.35 22.9798 12.67 23.1298 12 23.1298ZM12 3.3698C11.58 3.3698 11.17 3.4498 10.88 3.6198L5.37999 6.7998C3.74999 7.8998 3.74999 7.8998 3.74999 9.6098V15.3798C3.74999 17.0898 3.74999 17.0898 5.41999 18.2198L10.88 21.3698C11.47 21.7098 12.54 21.7098 13.13 21.3698L18.63 18.1898C20.25 17.0898 20.25 17.0898 20.25 15.3798V9.6098C20.25 7.8998 20.25 7.8998 18.58 6.7698L13.12 3.6198C12.83 3.4498 12.42 3.3698 12 3.3698Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.25C9.93 16.25 8.25 14.57 8.25 12.5C8.25 10.43 9.93 8.75 12 8.75C14.07 8.75 15.75 10.43 15.75 12.5C15.75 14.57 14.07 16.25 12 16.25ZM12 10.25C10.76 10.25 9.75 11.26 9.75 12.5C9.75 13.74 10.76 14.75 12 14.75C13.24 14.75 14.25 13.74 14.25 12.5C14.25 11.26 13.24 10.25 12 10.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ed68e3bffc9a1ceddfea3e352bd84cb7.svg";
export { ForwardRef as ReactComponent };